import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AssetTypesRoutingModule } from './asset-types-routing.module';
import {AssetTypesComponent} from "./asset-types.component";
import {AssetTypesEditComponent} from "./asset-types-edit/asset-types-edit.component";
import {AssetTypesViewComponent} from "./asset-types-view/asset-types-view.component";
import {AssetTypesFilterComponent} from "./asset-types-filter/asset-types-filter.component";
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {MatTableModule} from "@angular/material/table";
import {MatTooltipModule} from "@angular/material/tooltip";
import {PipesModule} from "../pipes/pipes.module";
import { AssetSubtypesComponent } from './asset-subtypes/asset-subtypes.component';
import { AssetTypesImporterComponent } from './asset-types-importer/asset-types-importer.component';
import {MatDialogModule} from "@angular/material/dialog";
import {MatDividerModule} from "@angular/material/divider";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {SharedModule} from "../shared/shared.module";
import {UtilsModule} from "../utils/utils.module";
import {FilesModule} from "../files/files.module";


@NgModule({
  declarations: [
    AssetTypesComponent,
    AssetTypesEditComponent,
    AssetTypesViewComponent,
    AssetTypesFilterComponent,
    AssetSubtypesComponent,
    AssetTypesImporterComponent
  ],
  imports: [
    CommonModule,
    AssetTypesRoutingModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatMenuModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    PipesModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    SharedModule,
    UtilsModule,
    FilesModule
  ]
})
export class AssetTypesModule { }
